import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

type Params = { id: string | undefined };

export type PartDto = ClientInferResponseBody<typeof contract.parts.findOne>;

export const fetchPart = async ({ id }: Params): Promise<PartDto> => {
  if (!id) {
    throw new Error("Part id is required");
  }

  const response = await api.parts.findOne.query({ params: { id } });
  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Part not found", response.status, response.body);
};
